module.exports = __webpack_public_path__ + "static/media/wallet.d523715b.png";